export async function checkLast() {
    const response = await fetch('/api/data/last');
    return await response.json();
}